"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryParameters = useQueryParameters;
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
function useQueryParameters() {
    const history = (0, react_router_1.useHistory)();
    function getQueryParams() {
        const urlSearchParams = new URLSearchParams(history.location.search);
        // @ts-ignore
        const params = Object.fromEntries(urlSearchParams.entries());
        return react_1.default.useMemo(() => params, [history.location.search]);
    }
    function createQueryParams(input) {
        let queryString = '';
        Object.keys(input).forEach(key => {
            const value = input[key];
            if (value !== undefined && value !== null) {
                const valueString = encodeURIComponent(value);
                queryString += queryString ? `&${key}=${valueString}` : `${key}=${valueString}`;
            }
        });
        return queryString;
    }
    return { createQueryParams, getQueryParams };
}
